export {
    type SupportedFeatures,
    type SupportedListNodeTagType,
    type SupportedTextFormatType,
    allSupportedFeatures,
    editorTheme,
} from './features';
export * from './tags';

export const RTEInitValue = '<p><span style="white-space: pre-wrap;"></span></p>';

export function extractTextWithNewLinesFromHtml(html: string): string {
    const document = new DOMParser().parseFromString(html, 'text/html').documentElement;

    const elementsWithLineBreaks = ['p', 'h4', 'li'];
    elementsWithLineBreaks.forEach((elementName) => {
        const elements = document.getElementsByTagName(elementName);
        for (let i = 0; i < elements.length; i++) {
            const element = elements[i];
            element.textContent = `${element.textContent}\n`;
        }
    });

    return document.textContent?.trim() || '';
}

export function getPlainTextLengthFromHtml(html: string): number {
    return new DOMParser().parseFromString(html, 'text/html').documentElement.textContent?.length ?? 0;
}
